import styled from 'styled-components';
import { Button as ButtonAtom } from 'components/atoms/button';

export const Button = styled(ButtonAtom)`
  && {
    padding: 0;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    & > .ant-typography {
      width: 100%;
      height: 100%;
    }

    & .ant-typography-copy {
      display: flex !important; /* NOTE:  we are overriding ant's inline-block */
      margin-left: 0;
      color: var(--gray-100);
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;

      &.ant-typography-copy-success {
        color: var(--success-color);
      }

      & svg {
        margin-right: 0;
      }
    }
  }
`;
